import { render, staticRenderFns } from "./referralComplete.vue?vue&type=template&id=0c6870d0&scoped=true"
import script from "./referralComplete.js?vue&type=script&lang=js&external"
export * from "./referralComplete.js?vue&type=script&lang=js&external"
import style0 from "./referralComplete.vue?vue&type=style&index=0&id=0c6870d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6870d0",
  null
  
)

export default component.exports